import { render, staticRenderFns } from "./CampaignBar.vue?vue&type=template&id=1582bada"
import script from "./CampaignBar.vue?vue&type=script&lang=js"
export * from "./CampaignBar.vue?vue&type=script&lang=js"
import style0 from "./CampaignBar.vue?vue&type=style&index=0&id=1582bada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports